import { cva, type VariantProps } from "class-variance-authority"
import * as React from "react"

import { cn } from "@/shared/lib/utils"

const statusBadgeVariants = cva(
	"inline-flex w-fit shrink-0 items-center justify-center whitespace-nowrap font-medium",
	{
		variants: {
			tone: {
				muted: "bg-muted text-muted-foreground",
				info: "bg-sky-400/15 text-sky-300",
				warning: "bg-amber-400/15 text-amber-300",
				success: "bg-emerald-400/15 text-emerald-300",
				danger: "bg-red-500/15 text-red-300",
			},
			size: {
				default: "h-5 rounded-full px-2 text-[11px]",
				compact: "rounded-full px-1.5 text-[10px] leading-4 font-semibold",
				tag: "rounded px-1.5 text-[10px] leading-4 font-semibold uppercase",
			},
		},
		defaultVariants: {
			tone: "muted",
			size: "default",
		},
	},
)

export interface StatusBadgeProps
	extends React.HTMLAttributes<HTMLSpanElement>,
		VariantProps<typeof statusBadgeVariants> {}

/** Small tone-coded status/label pill: consolidates the ad-hoc "rounded-full + translucent bg" chips used across the app. */
export function StatusBadge({ className, tone, size, ...props }: StatusBadgeProps) {
	return <span className={cn(statusBadgeVariants({ tone, size }), className)} {...props} />
}
